import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
  NewsletterParams,
  subscribeToNewsletter,
} from "src/api/services/newsletter/newsletterService";
import { useAuthContext } from "src/context/AuthContext";
import { useSnackbarContext } from "src/context/SnackbarContext";

export const useNewsletterMutation = () => {
  const { getValidToken } = useAuthContext();
  const { showSnackbar } = useSnackbarContext();
  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: async (params: NewsletterParams) => {
      const token = await getValidToken();
      if (!token) throw new Error("Missing JWT token");

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      return subscribeToNewsletter(params, headers);
    },
    onSuccess: () => {
      showSnackbar({
        message: t("FOOTER.NEWSLETTER.SUCCESS"),
        color: "success",
      });
    },
    onError: () => {
      showSnackbar({
        message: t("FOOTER.NEWSLETTER.ERROR"),
        color: "error",
      });
    },
  });

  return {
    subscribe: mutation.mutate,
    isSubscriptionSuccess: mutation.isSuccess,
    isSubscriptionPending: mutation.isPending,
    isSubscriptionError: mutation.isError,
  };
};
